export const SET_A_TABLIST = 'SET_A_TABLIST';
export const REMOVE_A_TABLIST = 'REMOVE_A_TABLIST';
export const CHANGE_TAB = 'CHANGE_TAB';